import request from '@/utils/request'

// 查找短信模版
export function findTemplate(params) {
  return request({
    url: '/bank/sms/template/findTemplate',
    method: 'get',
    params,
  })
}

// 停止短信解析器
export function stopSmsParser(id) {
  return request({
    url: `/bank/sms/template/stopSmsParser/${id}`,
    method: 'delete',
  })
}

// 获取无用的模版
export function getUselessTemplate(params) {
  return request({
    url: '/bank/sms/template/getUselessTemplate',
    method: 'get',
    params,
  })
}

// 获取执行中的短信模版
export function getRunningParser(id) {
  return request({
    url: `/bank/sms/template/getRunningParser/${id}`,
    method: 'get',
  })
}

// 短信模版检测重复解析
export function checkTemplateIsRepeatedParsing(data) {
  return request({
    url: '/bank/sms/template/checkTemplateIsRepeatedParsing',
    method: 'post',
    data: data,
  })
}

// 批量修改短信类型和状态
export function batchUpdateInstanceStatusAndType(data) {
  return request({
    url: '/bank/sms/instance/batchUpdateInstanceStatusAndType',
    method: 'post',
    data: data,
  })
}

// 取消指派操作员
export function unassignOperator(data) {
  return request({
    url: '/account/bank/unassignOperator',
    method: 'post',
    data: data,
  })
}

// 指派操作员
export function assignOperator(data) {
  return request({
    url: '/account/bank/assignOperator',
    method: 'post',
    data: data,
  })
}

// 编辑银行种类
export function updateAmsBankSetting(data) {
  return request({
    url: '/account/bank/updateAmsBankSetting',
    method: 'post',
    data: data,
  })
}

// 新增银行种类
export function addAmsBankSetting(data) {
  return request({
    url: '/account/bank/addAmsBankSetting',
    method: 'post',
    data: data,
  })
}

// 银行种类列表
export function listAmsBankSettings(params) {
  return request({
    url: '/account/bank/listAmsBankSettings',
    method: 'get',
    params: params,
  })
}

export function editBank(data) {
  return request({
    url: `/account/bank/updateBankAccount/${data.accId}`,
    method: 'patch',
    data: data,
  })
}

export function addBank(data) {
  return request({
    url: '/account/bank/addBankAccount',
    method: 'post',
    data: data,
  })
}

// export function getBankList() {
//   return request({
//     url: '/account/bank/bankList',
//     method: 'get',
//   })
// }

export function getBankReport() {
  return request({
    url: '/account/bank/report',
    method: 'get',
  })
}

// 获取银行帐户验证码
export function getBankAccountVerificationCode(accId) {
  return request({
    url: `/account/bank/bankAccountVerificationCode/${accId}`,
    method: 'get',
  })
}

// 获取银行列表
export function getBankLists(params) {
  return request({
    url: '/account/bank/listBanks',
    method: 'get',
    params: params,
  })
}

// 拉银行流水列表
export function createBankCardTurnover(data) {
  return request({
    url: '/account/bank/createBankCardTurnover',
    method: 'post',
    data: data,
  })
}

// 转移用户银行帐户
export function transferUserBankAccount(data) {
  return request({
    url: '/account/bank/transferUserBankAccount',
    method: 'post',
    data: data,
  })
}

// 跨总代转移
export function crossFirstAgentTransferUserBankAccount(data) {
  return request({
    url: 'account/bank/crossFirstAgent/transferUserBankAccount',
    method: 'post',
    data,
  })
}

/* =============== Start 短信模版管理 =============== */
// 新增短信模板
export function addTemplate(data) {
  return request({
    url: '/bank/sms/template/addTemplate',
    method: 'post',
    data: data,
  })
}
// 短信模板列表
export function listTemplates(params) {
  return request({
    url: '/bank/sms/template/listTemplates',
    method: 'get',
    params: params,
  })
}
// 全部的短信模板列表
export function listAllTemplate(params) {
  return request({
    url: '/bank/sms/template/allTemplate',
    method: 'get',
    params: params,
  })
}
// 获取短信模板对应的Regex Group Name列表
export function listTemplateRegexGroupNames(params) {
  return request({
    url: '/bank/sms/template/listTemplateRegexGroupNames',
    method: 'get',
    params: params,
  })
}
// 更新短信模版
export function updateTemplate(data) {
  return request({
    url: `/bank/sms/template/updateTemplate/${data.id}`,
    method: 'patch',
    data: data,
  })
}
// 热更新短信解析器
export function hotUpdateForSmsParser(data) {
  return request({
    url: '/bank/sms/template/hotUpdateForSmsParser',
    method: 'post',
    data: data,
  })
}
/* =============== Start 短信实例 =============== */
// 新增短信实例
export function addInstance(data) {
  return request({
    url: '/bank/sms/instance/addInstance',
    method: 'post',
    data: data,
  })
}
// 短信实例列表
export function listInstances(params) {
  return request({
    url: '/bank/sms/instance/listInstances',
    method: 'get',
    params: params,
  })
}
// 更新短信实例
export function updateInstance(data) {
  return request({
    url: `/bank/sms/instance/updateInstance/${data.id}`,
    method: 'patch',
    data: data,
  })
}
// 删除短信实例
export function deleteInstance(data) {
  return request({
    url: `/bank/sms/instance/deleteInstance/${data.id}`,
    method: 'delete',
  })
}

// 客制化测试Regex
export function smsTestCustomTestingRegex(data) {
  return request({
    url: '/bank/sms/test/customTestingRegex',
    method: 'post',
    data: data,
  })
}

// Sms客制化测试Regex
export function smsTestCustomTestingRegexForSms(data) {
  return request({
    url: '/bank/sms/test/customTestingRegexForSms',
    method: 'post',
    data: data,
  })
}
/* =============== End 短信模版管理 =============== */

//  批次汇入APK资讯
export function batchImportApkInfo(data) {
  return request({
    url: '/account/bank/batchImportApkInfo',
    method: 'post',
    data: data,
  })
}

// 删除APK资讯
export function deleteApkInfo(id) {
  return request({
    url: `/account/bank/deleteApkInfo/${id}`,
    method: 'delete',
  })
}

// 更新APK资讯
export function updateApkInfo(data) {
  return request({
    url: `/account/bank/updateApkInfo/${data.id}`,
    method: 'patch',
    data: data,
  })
}

// 获取未支援的号码列表
export function getNotSupportedPhoneNumberList(id) {
  return request({
    url: `/bank/sms/template/getNotSupportedPhoneNumberList/${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/bank.js